var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterLightBlueNoBgRoundedLightBlueBordered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 7.5,
    stroke: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0715 12.3648C11.1875 12.1414 11.4262 12 11.6875 12H32.3125C32.5738 12 32.8125 12.1414 32.9285 12.3648C33.0445 12.5883 33.0178 12.8552 32.8596 13.0537L24.75 23.2245V32.3438C24.75 32.5763 24.6211 32.7914 24.4111 32.9094C24.2012 33.0273 23.9416 33.0303 23.7286 32.9174L19.6036 30.7299C19.3854 30.6142 19.25 30.3946 19.25 30.1562V23.2245L11.1404 13.0537C10.9822 12.8552 10.9555 12.5883 11.0715 12.3648ZM13.0747 13.3125L20.4846 22.6057C20.5757 22.7199 20.625 22.8595 20.625 23.0031V29.7701L23.375 31.2284V23.0031C23.375 22.8595 23.4243 22.7199 23.5154 22.6057L30.9253 13.3125H13.0747Z",
    fill: "#5062F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterLightBlueNoBgRoundedLightBlueBordered);
export default __webpack_public_path__ + "static/media/filterLightBlueNoBgRoundedLightBlueBordered.3b99057e6ca4d442b25c81dc832f8b5e.svg";
export { ForwardRef as ReactComponent };